const getPositionInLine = ({ modelIndex, modelsPerRow }) => {
  return ((modelIndex + 1) % modelsPerRow)
}

export default getPositionInLine
